<template>
  <div id="card">
    <el-row>
      <el-button id="addBtn" type="primary" @click="toAddCustomer">添加色卡</el-button>
    </el-row>

    <el-table
      :data="tableData.list"
      :default-sort="{prop: 'date', order: 'descending'}"
      border
    >
      <el-table-column prop="id" label="色卡编号"></el-table-column>
      <el-table-column prop="cardName" label="色卡名称"></el-table-column>
      <el-table-column prop="model" label="型号"></el-table-column>
      <el-table-column prop="colorTotal" label="颜色数量"></el-table-column>
      <el-table-column prop="saveCount" label="已存数量"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button size="mini" @click="cardItem(scope.$index, scope.row)">查看</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="removeCustomer(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      @current-change="query"
      @size-change="changeSize"
      :current-page.sync="queryForm.pageNum"
      :page-sizes="[10,20,30,40,50]"
      :total="tableData.total"
      layout="total,sizes, prev, pager, next"
    ></el-pagination> -->

    <el-dialog title="添加色卡" :visible.sync="dialogFormVisible" :width="dialogWidth">
      <el-form :model="form">
        <el-form-item label="色卡名称" :label-width="formLabelWidth">
          <el-input v-model="form.cardName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="型号" :label-width="formLabelWidth">
          <el-input v-model="form.model" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="颜色数量" :label-width="formLabelWidth">
          <el-input v-model="form.colorTotal" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveCard">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新色卡" :visible.sync="updateFormVisible" :width="dialogWidth">
      <el-form :model="updateForm">
        <el-form-item label="色卡名称" :label-width="formLabelWidth">
          <el-input v-model="updateForm.cardName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="型号" :label-width="formLabelWidth">
          <el-input v-model="updateForm.model" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="颜色数量" :label-width="formLabelWidth">
          <el-input v-model="updateForm.colorTotal" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateCard">更 新</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      updateFormVisible: false,
      dialogFormVisible: false,
      form: {},
      updateForm: {},
      formLabelWidth: "120px",
      dialogWidth: "600px",
      queryForm: {}
    };
  },
  methods: {
    formatter(row) {
      return row.address;
    },
    toAddCustomer() {
      // this.$router.push("/customer/add");
      this.dialogFormVisible = true;
    },
    changeSize(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.query();
    },
    query() {
      var self = this;
      this.$axios
        .get("public/colorCard/query", { params: self.queryForm })
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.tableData = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    saveCard() {
      var self = this;
      this.$axios.post("colorCard/save", self.form).then(function(response) {
        if (response.data.errorCode == "00000") {
          self.dialogFormVisible = false;
          //清空表单
          self.form = {};
          self.$message({
            message: "保存成功",
            type: "success"
          });
          self.query();
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    removeCustomer(row) {
      var self = this;

      this.$confirm("此操作将永久删除该条记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .delete("colorCard/remove/" + row.id)
            .then(function(response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                self.query();
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleEdit(index, row) {
      console.log(JSON.stringify(row));
      this.updateForm = JSON.parse(JSON.stringify(row));
      this.updateFormVisible = true;
    },
    cardItem(index,row){
      this.$router.push("/mpindex/cardItem/"+row.id);
    },
    updateCard() {
      var self = this;
      this.$axios
        .post("colorCard/update", self.updateForm)
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.updateFormVisible = false;
            self.$message({
              message: "更新成功",
              type: "success"
            });
            self.query();
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    }
  },
  created: function() {
    console.log("mobileApp created");
    this.query();
  }
};
</script>

<style scoped>
#addBtn {
  float: right;
}
#queryForm {
  margin-top: 20px;
  margin-bottom: 20px;
}
.el-table {
  margin:auto;
  margin-top: 40px;
  margin-bottom: 20px;
  width: 90%;
}
</style>